export default __webpack_public_path__ + "locales/ar-SA/Files.json?hash=2b363d74acbad6fdf2147560105e8072";